$(document).ready(function () {


    if ($(window).width() > 1079) {
        $('.column-promo .column-reviews-slider').slick({
            dots: true,
            arrows: false,
            infinite: true,
            adaptiveHeight: true,
            fade: true,
            accessibility: false,
            autoplay: true,
            autoplaySpeed: 3000,
            slidesToShow: 1,
            slidesToScroll: 1
        });
        $('.column-promo .column-reviews-slider').on('init swipe afterChange', function (event, slick, currentSlide, nextSlide) {
            var i = currentSlide + 1;
            $('.column-promo .column-reviews-slider .slick-dots li button').attr('aria-current', 'false');
            $('.column-promo .column-reviews-slider .slick-dots li button').removeAttr('aria-expanded');
            $(this).find('.slick-dots li:nth-child(' + i + ') button').attr('aria-current', 'true');
            $(this).find('.slick-dots li:nth-child(' + i + ') button').attr('aria-label', 'Go to slide ' + i);
        });
    } else {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }


    $('.js-mobile-menu-toggle').click(function () {
        $('html').addClass('lock');
        $('#mobile-menu').toggleClass('is-open');
        $('body').toggleClass('mobile-menu--open');
        $('.mobile-menu__close').focus();
    });

    $('body').on('click', '.mobile-menu__close', function () {
        $('html').removeClass('lock');
        $('#mobile-menu').removeClass('is-open');
        $('.mega-menu-custom').removeClass('is-open');
        $('#mobile-menu button').removeClass('is-open');
        $('body').removeClass('mobile-menu--open');
    });

    $('body').on('click', '.mobile-menu .x-menu--level-1--link button', function () {
        $(this).parent().attr('data-x-menu--open', 'true');
        $('.js-mobile-menu-holder').addClass('sub--open');
        $(this).parent().find(".js-back-button").focus();
    });

    $('body').on('click', '.mega-menu-custom .mobile-menu__header .js-close-button', function () {
        $(this).parents('.x-menu--level-1--link').attr('data-x-menu--open', 'false');
        $('.mega-menu__shop-online').removeClass('open');
        $('.js-mobile-menu-holder').removeClass('sub--open');
        $('.mega-menu-custom').removeClass('is-open');
        $('.mega-menu-custom').removeClass('shop-online__open');
        $('html').removeClass('lock');
        $('#mobile-menu').removeClass('is-open');
        $('#mobile-menu button').removeClass('is-open');
        $('body').removeClass('mobile-menu--open');
    });
    $('body').on('click', '.mega-menu-custom .mobile-menu__header .js-back-button', function () {
        $(this).parents('.x-menu--level-1--link').attr('data-x-menu--open', 'false');
        $('.mega-menu__shop-online').removeClass('open');
        $('.js-mobile-menu-holder').removeClass('sub--open');
        $('.mega-menu-custom').removeClass('is-open');
        $('.mega-menu-custom').removeClass('shop-online__open');
        $('#mobile-menu button').removeClass('is-open');
        $(this).parents("li").find("button.x-menu-a")?.focus();
    });


    $('.x-menu--mega').hover(function () {
        $(this).attr('data-x-menu--open', 'true');
        $(this).find('.mega-menu-custom').attr('data-transition', 'forwards');
        $(this).find('button:not(#mega-menu__shop-online):not(.shop-online__close)').attr('aria-expanded', 'true');
        $('.column-promo .column-reviews-slider').slick('slickAdd');
    }, function () {
        $(this).attr('data-x-menu--open', 'false');
        $(this).find('.mega-menu-custom').attr('data-transition', 'backwards');
        $(this).find('button:not(#mega-menu__shop-online):not(.shop-online__close)').attr('aria-expanded', 'false');
        $('.mega-menu__shop-online').removeClass('open');
        $('.mega-menu__shop-online .column-promo').removeClass('animate__fadeIn');
    });

    $('.x-menu--mega .x-menu-a').click(function () {
        var open = $(this).parent().attr('data-x-menu--open');
        if (open == 'false') {
            $(this).parent().attr('data-x-menu--open', 'true');
            $(this).parent().find('.mega-menu-custom').attr('data-transition', 'forwards');
            $(this).parent().find('button:not(#mega-menu__shop-online):not(.shop-online__close)').attr('aria-expanded', 'true');
            $('.column-promo .column-reviews-slider').slick('slickAdd');
        } else {
            $(this).parent().attr('data-x-menu--open', 'false');
            $(this).parent().find('.mega-menu-custom').attr('data-transition', 'backwards');
            $(this).parent().find('button:not(#mega-menu__shop-online):not(.shop-online__close)').attr('aria-expanded', 'false');
            $('.mega-menu__shop-online').removeClass('open');
            $('.mega-menu__shop-online .column-promo').removeClass('animate__fadeIn');
        }
    });

    $('body').on('click', '#mega-menu__shop-online', function (e) {
        e.preventDefault();
        $(".mega-menu-custom").animate({scrollTop: 0});
        $('.mega-menu__shop-online .column-promo').addClass('animate__fadeIn');
        $('.mega-menu__shop-online').addClass('open');
        $('.mega-menu-custom').addClass('shop-online__open');
        if ($(window).width() < 1080) {
            $('.column-promo .column-reviews-slider').slick({
                dots: true,
                arrows: false,
                infinite: true,
                adaptiveHeight: true,
                fade: true,
                accessibility: false,
                autoplay: true,
                autoplaySpeed: 3000,
                slidesToShow: 1,
                slidesToScroll: 1
            });
            $('.column-promo .column-reviews-slider').slick('slickAdd');
        }
    });
    $('.mega-menu__shop-online .shop-online__close').click(function () {
        if ($(window).width() >= 1080) {
            $('.mega-menu__shop-online').removeClass('open');
            $('.mega-menu__shop-online .column-promo').removeClass('animate__fadeIn');
        } else {
            $(this).parents('.x-menu--mega').attr('data-x-menu--open', 'false');
            $(this).parents('.x-menu--mega').find('.mega-menu-custom').attr('data-transition', 'backwards');
            $(this).parents('.x-menu--mega').find('button:not(#mega-menu__shop-online):not(.shop-online__close)').attr('aria-expanded', 'false');
            $('.mega-menu__shop-online').removeClass('open');
            $('.mega-menu-custom').removeClass('shop-online__open');
            $('.mega-menu__shop-online .column-promo').removeClass('animate__fadeIn');
        }
    });


    var dialog = document.querySelector('[role="dialog"]');
    var firstFocusableElement = dialog.querySelector('.shop-online__close');
    var lastFocusableElement = dialog.querySelector('[role="button"]');

    dialog.addEventListener('keydown', function (e) {
        if (e.target == firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
            e.preventDefault();
            lastFocusableElement.focus();
        } else if (e.target == lastFocusableElement && e.key == 'Tab' && !e.shiftKey) {
            e.preventDefault();
            firstFocusableElement.focus();
        }
    });

});


$(window).mousemove(function () {
    setTimeout(function () {
        $('.template-index').addClass('header--animated');
    }, 3000);
    setTimeout(function () {
        $('.template-index').addClass('header--animated-fadein');
    }, 3500);
});
$(window).scroll(function () {
    $('.template-index').addClass('header--animated');
    $('.template-index').addClass('header--animated-fadein');
});
$('a, .x-menu--level-1--link, .header--cart').hover(function () {
    $('.template-index').addClass('header--animated');
    $('.template-index').addClass('header--animated-fadein');
});


$(window).scroll(function () {
    if ($(window).scrollTop() > 40) {
        $('body').addClass('fixed-header');
    } else {
        $('body').removeClass('fixed-header');
    }

});

$(function () {
    $('body').on('click', '.js-footer-menu-toggle', function () {
        setTimeout(function () {
            $(this).toggleClass('is-open');
        }, 10);
    });

});